/* Maps an audit/activity record's entity to its drill-down route. Returns null when not navigable. */
export function entityLink(entityType, entityId) {
  if (!entityType) return null;
  switch (entityType) {
    case "requisition":
      return entityId ? `/requisitions/${entityId}` : "/requisitions";
    case "candidate":
      return entityId ? `/candidates/${entityId}` : "/candidates";
    case "interview":
      return "/interviews";
    case "offer":
      return "/offers";
    case "kb_source":
    case "agent_session":
      return "/agent";
    case "integration":
    case "hrone_mapping":
      return "/integrations";
    case "entities":
    case "departments":
    case "locations":
    case "salary-bands":
    case "workflows":
      return "/master-data";
    case "jd":
      return "/requisitions";
    default:
      return null;
  }
}
